// extracted by mini-css-extract-plugin
export default {"container":"Slides_container__oJ5pU","header":"Slides_header__pTsUC"};